import { useNavigate as reactRouterUseNavigate } from 'react-router-dom';
var useNavigate = function () {
    var reactRouterNavigate = reactRouterUseNavigate();
    var navigate = function (to, options) {
        if (typeof to === 'number') {
            return reactRouterNavigate(to);
        }
        // This is to handle external links: https://sim.amazon.com/issues/HMLTN-2037
        // TODO: There should be a better way to handle external links.
        if (options === null || options === void 0 ? void 0 : options.external) {
            return window.location.assign(to);
        }
        if (options) {
            return reactRouterNavigate(to, options);
        }
        else {
            return reactRouterNavigate(to);
        }
    };
    return navigate;
};
export { useNavigate };
